import api from './api';
import { 
  LoginCredentials, 
  AuthResponse,
  RefreshTokenResponse
} from '../types/auth';
import { extractErrorMessage } from '../utils/error-utils';

export class AuthService {
  static async login(credentials: LoginCredentials): Promise<AuthResponse> {
    try {
      const response = await api.post(`/auth/login`, credentials);
      return response.data;
    } catch (error: any) {
      // Ensure we throw an error with a message
      throw new Error(extractErrorMessage(error, 'Invalid credentials'));
    }
  }

  static async loginWithOtp(payload: any): Promise<any> {
    try {
      const response = await api.post(`/auth/login/otp`, payload);
      return response.data;
    } catch (error: any) {
      throw new Error(extractErrorMessage(error, 'Invalid OTP or login'));
    }
  }

  static async logout(): Promise<void> {
    try {
      await api.post(`/auth/logout`);
    } catch (error) {
      console.error('Logout failed:', error);
      // Don't throw error on logout failure
    }
  }

  static async refreshToken(): Promise<RefreshTokenResponse> {
    try {
      // Refresh token is sent automatically via httpOnly cookie
      const response = await api.post(`/auth/refresh-token`);
      
      // Store new access token
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
      }
      
      return response.data;
    } catch (error: any) {
      // Clear token on refresh failure
      localStorage.removeItem('token');
      throw new Error(extractErrorMessage(error, 'Token refresh failed'));
    }
  }
}
